/* Plantilla de producto premium "mi-" — Maison Idalia */
(function () {
  var section = document.querySelector('.mi-pdp');
  var root = section ? section.closest('[data-section-type="product"]') || section : null;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  /* ---------- Precio, stock y barra fija al cambiar de variante ---------- */
  function onVariant(v) {
    if (!v) return;
    var price = document.querySelector('[data-mi-price]');
    if (price) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      price.querySelector('[data-mi-current]').innerHTML = money(v.price);
      var compare = price.querySelector('[data-mi-compare]');
      var badge = price.querySelector('[data-mi-badge]');
      compare.hidden = badge.hidden = !onSale;
      if (onSale) {
        compare.innerHTML = money(v.compare_at_price);
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        badge.textContent = price.dataset.label.replace('[percent]', pct);
      }
    }
    var stock = document.querySelector('[data-mi-stock]');
    if (stock) {
      var inv = {};
      try { inv = JSON.parse('{' + stock.dataset.inv + '}'); } catch (e) {}
      var q = inv[v.id];
      var n = (q && q > 0 && q <= +stock.dataset.max) ? q : stock.dataset.fallback;
      stock.querySelector('[data-mi-stock-text]').textContent = stock.dataset.label.replace('[count]', n);
    }
    var sp = document.querySelector('[data-mi-sticky-price]');
    if (sp) {
      sp.innerHTML = money(v.price);
      var sc = document.querySelector('[data-mi-sticky-compare]');
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      sc.hidden = !sale;
      if (sale) sc.innerHTML = money(v.compare_at_price);
    }
  }
  if (root) {
    root.addEventListener('variantChange', function (e) { onVariant(e.detail && e.detail.variant); });
  }

  /* ---------- Swatches de color con la imagen de la variante ---------- */
  var swData = document.querySelector('[data-mi-swatches]');
  if (swData && section) {
    var map = {};
    try { map = JSON.parse(swData.textContent); } catch (e) {}
    section.querySelectorAll('.color-swatch').forEach(function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      var val = input && input.value;
      if (val && map[val]) {
        label.style.backgroundImage = 'url(' + map[val] + ')';
        label.style.backgroundSize = 'cover';
      }
    });
  }

  /* ---------- Texto del botón ---------- */
  if (window.miBtnText && section) {
    section.querySelectorAll('[data-add-to-cart-text]').forEach(function (el) {
      if (el.dataset.defaultText) el.dataset.defaultText = window.miBtnText;
      var btn = el.closest('button');
      if (!btn || !btn.disabled) el.textContent = window.miBtnText;
    });
  }

  /* ---------- Fecha de envío ---------- */
  document.querySelectorAll('[data-mi-ship]').forEach(function (el) {
    var d = new Date();
    var days = +el.dataset.days;
    var skip = el.dataset.skip === 'true';
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (skip && (d.getDay() === 0 || d.getDay() === 6)) continue;
      days--;
    }
    if (skip) while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var txt = d.toLocaleDateString('pt-PT', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '');
    el.querySelector('[data-mi-ship-date]').textContent = txt;
  });

  /* ---------- Mini carrusel de reseñas ---------- */
  document.querySelectorAll('[data-mi-rslider]').forEach(function (el) {
    var track = el.querySelector('.mi-rslider__track');
    var n = track.children.length, i = 0;
    function go(k) { i = (k + n) % n; track.style.transform = 'translateX(' + (-100 * i) + '%)'; }
    el.querySelector('[data-mi-prev]').addEventListener('click', function () { go(i - 1); });
    el.querySelector('[data-mi-next]').addEventListener('click', function () { go(i + 1); });
    if (n > 1) setInterval(function () { if (!el.matches(':hover')) go(i + 1); }, 5000);
  });

  /* ---------- Carruseles (reseñas con fotos, completa el look) ---------- */
  function initCarousel(el) {
    var track = el.querySelector('[data-mi-track]');
    var prev = el.querySelector('[data-mi-prev]');
    var next = el.querySelector('[data-mi-next]');
    if (!track || !prev || !next) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 300; }
    function update() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  document.querySelectorAll('[data-mi-carousel]').forEach(function (el) {
    if (!el.closest('[data-mi-related]')) initCarousel(el);
  });

  /* ---------- Recomendaciones "Completa el look" ---------- */
  document.querySelectorAll('[data-mi-related]').forEach(function (wrap) {
    fetch(wrap.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('[data-mi-related-list]');
        var target = wrap.querySelector('[data-mi-related-list]');
        if (list && list.children.length) {
          target.innerHTML = list.innerHTML;
        } else {
          wrap.classList.add('is-empty');
        }
        initCarousel(wrap.querySelector('[data-mi-carousel]'));
      })
      .catch(function () { wrap.classList.add('is-empty'); });
  });

  /* ---------- Modal guía de tallas ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mi-modal-open]');
    if (open) {
      var m = document.getElementById(open.dataset.miModalOpen);
      if (m) { document.body.appendChild(m); m.hidden = false; }
      return;
    }
    var close = e.target.closest('[data-mi-modal-close]');
    if (close) close.closest('.mi-modal').hidden = true;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.mi-modal').forEach(function (m) { m.hidden = true; });
  });

  /* ---------- Barra fija de compra ---------- */
  var sticky = document.querySelector('[data-mi-sticky]');
  var mainBtn = section && section.querySelector('.add-to-cart');
  if (sticky && mainBtn) {
    sticky.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
    io.observe(mainBtn);
    sticky.querySelector('[data-mi-sticky-btn]').addEventListener('click', function () {
      if (mainBtn.disabled) {
        mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        mainBtn.click();
      }
    });
  } else if (sticky) {
    sticky.remove();
  }
})();
